export enum NamingConventionType {
  Report,
  ExportExcel,
  Attachment,
  Appendix,
}

export const NamingConventionTypeMap = new Map<number, string>([
  [NamingConventionType.Report, 'report'],
  [NamingConventionType.ExportExcel, 'excel'],
  [NamingConventionType.Attachment, 'attachment'],
  [NamingConventionType.Appendix, 'appendix'],
]);

export const TitleFilenames = $localize`:@@shared.namingConventionType.titleFilenames:Filenames`;

export const NamingConventionStaticMessageText = new Map<number, string>([
  [
    NamingConventionType.Report,
    $localize`:@@shared.namingConventionType.titleReport:Report`,
  ],
  [
    NamingConventionType.ExportExcel,
    $localize`:@@shared.namingConventionType.titleExcel:Excel`,
  ],
  [
    NamingConventionType.Attachment,
    $localize`:@@shared.namingConventionType.titleAttachment:Attachment`,
  ],
  [
    NamingConventionType.Appendix,
    $localize`:@@shared.namingConventionType.titleAppendix:Appendix`,
  ],
]);
